import { useMemo } from 'react'

import { SortingState } from '@tanstack/react-table'
import { useQuery } from 'react-query'

import {
  BulkMessagePageResponse,
  massMessageService,
} from '@/modules/online-mass-messages/service/mass-message-service.ts'

interface UseMassMessageTableProps {
  creatorId?: number
  page: number
  size: number
  sortOption: SortingState
}

export const useMassMessageTable = ({
  creatorId,
  page,
  size,
  sortOption,
}: UseMassMessageTableProps) => {
  const { data, isFetching, isIdle } = useQuery<BulkMessagePageResponse>(
    ['mass-messages', creatorId, { page, size }, sortOption],
    () =>
      massMessageService.fetchMassMessages({
        creatorId,
        page,
        size,
        sortOption,
      }),
    {
      keepPreviousData: true,
      enabled: !!creatorId,
    },
  )

  return useMemo(() => {
    return {
      data,
      isFetching: isFetching || isIdle,
    }
  }, [data, isFetching, isIdle])
}
